import * as React from "react";
import { Path, Rect, G, Defs, ClipPath, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const CDIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="CD" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#3195F9"
        fillRule="evenodd"
        d="M0 0v12h16V0H0Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={16}
        height={12}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M0 0v12h16V0H0Z"
          clipRule="evenodd"
        />
      </Mask>
      <G mask="url(#b)">
        <Path
          fill="#E31D1C"
          stroke="#FECA00"
          strokeWidth={1.25}
          d="m17.149-1.74 1.11 1.664.347.52-.52.347-18.13 12.102-.52.346-.347-.52-1.11-1.663-.348-.52.521-.346 18.13-12.102.52-.348.347.52Z"
        />
        <Path
          fill="#FECA00"
          fillRule="evenodd"
          d="M2.465 4.303.723 5.512l.556-2.07L0 2.119l1.732-.072L2.465 0l.733 2.047h1.73L3.65 3.442l.64 1.948-1.826-1.087Z"
          clipRule="evenodd"
        />
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
